import { Component } from '@angular/core';

@Component({
	selector: 'app-pages',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss'],
})
export class PageComponent {}
